import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetOtherUseByConservationTypesInputDto, OtherUseByConservationTypeCreateDto, OtherUseByConservationTypeDto, OtherUseByConservationTypeExcelDownloadDto, OtherUseByConservationTypeUpdateDto } from '../dtos/other-use-by-conservation-type/models';
import type { DeleteBulkByIdsInputDto, DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class OtherUseByConservationTypeService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: OtherUseByConservationTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseByConservationTypeDto>({
      method: 'POST',
      url: '/api/geographic/otherUseByConservationTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/otherUseByConservationTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteBulkByIds = (input: DeleteBulkByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/otherUseByConservationTypes/by-ids-bulk',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/otherUseByConservationTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseByConservationTypeDto>({
      method: 'GET',
      url: `/api/geographic/otherUseByConservationTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/otherUseByConservationTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetOtherUseByConservationTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OtherUseByConservationTypeDto>>({
      method: 'GET',
      url: '/api/geographic/otherUseByConservationTypes',
      params: { otherUseId: input.otherUseId, registerLocationId: input.registerLocationId, conservationTypeId: input.conservationTypeId, hectare: input.hectare, hectareFrom: input.hectareFrom, hectareTo: input.hectareTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: OtherUseByConservationTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/otherUseByConservationTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, otherUseId: input.otherUseId, registerLocationId: input.registerLocationId, conservationTypeId: input.conservationTypeId, hectare: input.hectare, hectareFrom: input.hectareFrom, hectareTo: input.hectareTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseByConservationTypeDto[]>({
      method: 'GET',
      url: '/api/geographic/otherUseByConservationTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: OtherUseByConservationTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseByConservationTypeDto>({
      method: 'PUT',
      url: `/api/geographic/otherUseByConservationTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}